import React from 'react'
import { Button } from 'lib/ui/components'
import { useCheckoutSuccess } from 'lib/modules/checkout'
import { CheckoutLayout } from '../styled'
import {
  Container as SuccessContainer,
  Wrapper,
  OrderSuccessContentWrapper
} from './styled'
import { useJustunoConversion } from 'modules/justuno'
import { useHistory } from 'react-router-dom'
import { Survey } from 'app/livbrite/scenes/Home/components/Survey'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/livbrite/resources/constants'

interface CmsBlockData {
  id: string
  updatedAt?: number
  content: string
  isSuccess: boolean
  isFailure: boolean
  isFirstLoad: boolean
}

export const Success = () => {
  const { orderId } = useCheckoutSuccess()
  useJustunoConversion(orderId)
  const history = useHistory()
  const orderSuccessContentId = CMS_BLOCK.ORDER_SUCCESS_CONTENT_LB

  const orderSuccessContentBlock = useCmsBlock({
    id: orderSuccessContentId,
    isLazy: false
  }) as CmsBlockData

  return (
    <>
      <Wrapper>
        <h1>Thank you!</h1>
        <CheckoutLayout>
          <SuccessContainer>
            <p>Thank you for your order.</p>
            <p>
              You will be receiving an order confirmation shortly and then we
              will let you know when your order has shipped!
            </p>
            <div className='actions'>
              <Button onClick={() => history.push('/bladder-control')}>
                Continue Shopping
              </Button>
            </div>
          </SuccessContainer>
          {orderSuccessContentBlock.isSuccess && (
            <OrderSuccessContentWrapper
              dangerouslySetInnerHTML={{
                __html: orderSuccessContentBlock?.content ?? ''
              }}
            />
          )}
          <div className='survey-wrapper'>
            <h2>Your journey to feeling your best starts right here</h2>
            <Survey />
          </div>
          {orderSuccessContentBlock.isSuccess && (
            <OrderSuccessContentWrapper
              dangerouslySetInnerHTML={{
                __html: orderSuccessContentBlock?.content ?? ''
              }}
            />
          )}
        </CheckoutLayout>
      </Wrapper>
    </>
  )
}
